import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  { path: 'members', redirectTo: 'members/list', pathMatch: 'full' },
  {
    path: 'members',
    children: [
      {
        path: 'list/:id',
        loadComponent: () => import('./list/members.component').then((m) => m.MembersComponent),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class membersRoutingModule {
  static routes = admin;
}
